// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { TKeys } from './types';

const localePt: { pt: { [key in TKeys]: string } } = {
  pt: {
    PAGE_TITLE: 'Viva a experiência por 7 dias',
    PAGE_DESCRIPTION:
      'Preencha seu formulário para ativar seu teste gratuito 🎉',

    TRIAL_FORM_TITLE: 'Viva a experiência por 7 dias',
    TRIAL_FORM_DESCRIPTION:
      'Preencha o seu formulário para ativar o seu teste gratuito',
    TRIAL_FORM_NAME: 'Nome',
    TRIAL_FORM_LAST_NAME: 'Sobrenome',
    TRIAL_FORM_PHONE: 'Número de telefone',
    TRIAL_FORM_EMAIL: 'Email corporativo',
    TRIAL_FORM_ROLE: 'Posição ou posição',
    TRIAL_FORM_COMPANY: 'Company',
    TRIAL_FORM_ORGANIZATION_SIZE: 'Tamanho da empresa',
    TRIAL_FORM_COUNTRY: 'País',
    TRIAL_FORM_TERMS_1: 'Solicitando a demonstração eu aceito o',
    TRIAL_FORM_TERMS_2: 'termos e condições',
    TRIAL_FORM_TERMS_3: 'de Crehana',
    TRIAL_FORM_SUBMIT_1: 'Enviando...',
    TRIAL_FORM_SUBMIT_2: 'Enviar agora',
    TRIAL_FORM_MAX_LENGTH_15: 'Máximo 15 caracteres',
    TRIAL_FORM_PHONE_PATTERN: 'Por favor, digite um número de telefone válido',
    TRIAL_FORM_EMAIL_PATTERN: 'Por favor, insira um endereço de e-mail válido',

    TRIAL_FORM_COUNTRY_1: 'Argentina',
    TRIAL_FORM_COUNTRY_2: 'Belize',
    TRIAL_FORM_COUNTRY_3: 'Bolívia',
    TRIAL_FORM_COUNTRY_4: 'Brasil',
    TRIAL_FORM_COUNTRY_5: 'Chile',
    TRIAL_FORM_COUNTRY_6: 'Colômbia',
    TRIAL_FORM_COUNTRY_7: 'Costa Rica',
    TRIAL_FORM_COUNTRY_8: 'Cuba',
    TRIAL_FORM_COUNTRY_9: 'Equador',
    TRIAL_FORM_COUNTRY_10: 'El Salvador',
    TRIAL_FORM_COUNTRY_12: 'Espanha',
    TRIAL_FORM_COUNTRY_13: 'Estados Unidos da América',
    TRIAL_FORM_COUNTRY_14: 'Guatemala',
    TRIAL_FORM_COUNTRY_15: 'Honduras',
    TRIAL_FORM_COUNTRY_16: 'México',
    TRIAL_FORM_COUNTRY_17: 'Nicarágua',
    TRIAL_FORM_COUNTRY_18: 'Panamá',
    TRIAL_FORM_COUNTRY_19: 'Paraguai',
    TRIAL_FORM_COUNTRY_20: 'Peru',
    TRIAL_FORM_COUNTRY_21: 'Porto Rico',
    TRIAL_FORM_COUNTRY_22: 'República Dominicana',
    TRIAL_FORM_COUNTRY_23: 'Uruguai',
    TRIAL_FORM_COUNTRY_24: 'Venezuela',
    TRIAL_FORM_COUNTRY_25: 'Outros',

    TRIAL_FORM_COMPANY_SIZE_1: 'Até 150 personas',
    TRIAL_FORM_COMPANY_SIZE_2: 'De 151 a 1000 personas',
    TRIAL_FORM_COMPANY_SIZE_3: 'De 1001 a 5000 personas',
    TRIAL_FORM_COMPANY_SIZE_4: 'De 5001 a 5000 a mais personas',

    CONFIRMATION_DIALOG_TITLE: 'Muito obrigado por \n registrar seus dados',
    CONFIRMATION_DIALOG_DESCRIPTION:
      'Estaremos nos comunicando com você em breve \n para que você possa viver esta experiência.',
    CONFIRMATION_DIALOG_BUTTON: 'Concluir',

    SUCESS_DIALOG_TITLE: 'Obrigado por registrar seus dados!',
    SUCCESS_DIALOG_TITLE_DOWNLOADABLE: 'Agora você pode baixar seu conteúdo!',
    SUCCESS_DIALOG_CTA_DOWNLOADABLE: 'Download',
    SUCESS_DIALOG_BODY:
      'Um consultor entrará em contato com você em breve para fornecer mais informações.',
    SUCESS_DIALOG_BUTTON: 'Entendido',

    LOADER_FINAL_STEP_TITLE: 'Obrigado {{name}} por registrar seus dados!',
    LOADER_FINAL_STEP_1: 'Analisando as características de sua empresa',
    LOADER_FINAL_STEP_2:
      'Entrando em contato com o melhor consultor de acordo com suas necessidades',
    LOADER_FINAL_STEP_3: 'Juntando uma proposta para Planos de Equipe',
    LOADER_FINAL_STEP_4:
      'Construindo trilhas de aprendizagem de acordo com sua indústria',

    FORM_BY_STEPS_NAME_LABEL: 'Nome',
    FORM_BY_STEPS_NAME_HINT: 'Digite seu nome',
    FORM_BY_STEPS_LASTNAME_LABEL: 'Sobrenome',
    FORM_BY_STEPS_LASTNAME_HINT: 'Por favor, digite seu sobrenome',
    FORM_BY_STEPS_NEXT_BUTTON: 'Continuar',
    FORM_BY_STEPS_COUNTRY_LABEL: 'País',
    FORM_BY_STEPS_COUNTRY_HINT: 'Selecione um país',
    FORM_BY_STEPS_EMAIL_LABEL: 'Correio corporativo',
    FORM_BY_STEPS_EMAIL_HINT: 'Escreva seu e-mail corporativo',
    FORM_BY_STEPS_EMAIL_ERROR: 'Por favor, insira um endereço de e-mail válido',
    FORM_BY_STEPS_COMPANY_LABEL: 'Empresa',
    FORM_BY_STEPS_COMPANY_HINT: 'Escreva o nome da sua empresa',
    FORM_BY_STEPS_ROLE_LABEL: 'Posição ou posição',
    FORM_BY_STEPS_ROLE_HINT: 'Escreva sua posição ou título',
    FORM_BY_STEPS_PHONE_LABEL: 'Número de telefone',
    FORM_BY_STEPS_BANNER_ERROR: 'Ocorreu um erro ao enviar.',
    FORM_BY_STEPS_DEMO_REQUEST:
      'Quero receber uma demonstração personalizada do Crehana for Business',
    FORM_BY_STEPS_PROMOTION:
      'Quero receber promoções e novidades da Crehana for Business',

    LOADER_FINAL_COUNT_TITLE: 'Concluído',

    FORM_STEPS_CONTEXT_1:
      'Olá, sou a Carolina, qual é o seu nome para começar?',
    FORM_STEPS_CONTEXT_2: 'Ótimo! De onde é?',
    FORM_STEPS_CONTEXT_3:
      'Estamos indo muito bem! Qual é o seu e-mail corporativo?',
    FORM_STEPS_CONTEXT_4:
      'Vamos falar sobre sua organização. Qual é o nome da sua empresa?',
    FORM_STEPS_CONTEXT_5: 'Excelente! Diga-me o tamanho da sua empresa.',
    FORM_STEPS_CONTEXT_6:
      'Alguns detalhes finais. Qual é a sua posição ou título?',
    FORM_STEPS_CONTEXT_7: 'Em que departamento você trabalha?',
    FORM_STEPS_CONTEXT_8: 'Para terminar. Qual é o teu número de telefone?',

    VALIDATIONS_REQUIRED: 'Campo obrigatório',
    VALIDATIONS_MAX_LENGTH: '`` Máximo de {{max}} caracteres',

    NAME_LABEL: 'Nome',
    REQUIRED_FIELD: 'Campo obrigatório',
    REQUIRED_NAME: 'Nome obrigatório',
    INVALID_NAME: 'O nome é inválido',
    LAST_NAME_LABEL: 'Sobrenome',
    REQUIRED_LAST_NAME: 'Sobrenome obrigatório',
    INVALID_LAST_NAME: 'O sobrenome é inválido',
    //  step completed
    STEP_COMPLETED_TITLE: 'Você solicitou um teste de demonstração',
    STEP_COMPLETED_SUB_TITLE:
      'Un asesor se comunicará contigo para ayudarte y brindarte más información.',
    STEP_COMPLETED_CTA_LABEL: 'É entendido',

    // User Departments
    USER_DEPARTMENT_HINT: 'Selecione uma opção',
    USER_DEPARTMENT_LABEL: 'Area de trabalho',
    //
    USER_DEPARTMENT_HR: 'Recursos humanos',
    USER_DEPARTMENT_INNOVATION_IT: 'Innovación',
    USER_DEPARTMENT_MARKETING: 'Marketing',
    USER_DEPARTMENT_MANAGEMENT: 'Administración',
    USER_DEPARTMENT_SALES: 'Vendas',
    USER_DEPARTMENT_TI: 'TI',
    USER_DEPARTMENT_OPERATIONS: 'Operações',
    USER_DEPARTMENT_FINANCES: 'Finança',
    USER_DEPARTMENT_OTHER: 'Outros',

    // User roles
    USER_ROLE_HINT: 'Selecione uma opção',
    USER_ROLE_LABEL: 'Cargo',
    //
    USER_ROLE_CEO: 'CEO/Gerente geral',
    USER_ROLE_C_LEVEL: 'C Level/Gerente',
    USER_ROLE_VP: 'Vice-presidente',
    USER_ROLE_MANAGER: 'Manager',
    USER_ROLE_FOUNDER: 'Fundador',
    USER_ROLE_DIRECTOR: 'Diretora',
    USER_ROLE_COORDINATOR: 'Coordenador',
    USER_ROLE_EXECUTIVE: 'Executivo',
    USER_ROLE_ANALIST: 'Analista',
    USER_ROLE_INTERN: 'Praticante/Estagiário',
    USER_ROLE_FREELANCE: 'Independente',
    USER_ROLE_STUDENT: 'Estudiante',
    USER_ROLE_OTHER: 'Otro',
  },
};

export default localePt;
